import { FormControlLabel, Switch } from '@material-ui/core'
import { useEffect } from 'react'
import { useTranslate } from 'react-admin'

const BooleanInput = ({
  source,
  label,
  required,
  type,
  record,
  setPayload,
  payload,
  ...props
}) => {
  const translate = useTranslate()
  useEffect(() => {
    setPayload({ ...payload, [source]: record[source] })
  }, [record])
  const handleChange = (e) => {
    setPayload({ ...payload, [source]: e.target.checked })
  }

  return (
    <>
      <FormControlLabel
        control={<Switch checked={payload[source]} onChange={handleChange} />}
        label={translate(label, { _: label })}
      />
    </>
  )
}
export default BooleanInput
